import React from 'react';

const Empty = () => (<div style={{ padding: '30px 20px' }}>
  {'Данный раздел находится в стадии разработки. Извините за предоставленные неудобства!'}
</div>);

export default Empty;
